function renderFieldJsxFieldControllerTemplate({
  name,
  fieldContainerClassFill,
  formLabelWithDescriptionLine,
  placeholder,
  textareaClass,
  errorMessageLine
}: {
  name: string
  fieldContainerClassFill: string
  formLabelWithDescriptionLine: string
  placeholder: string
  textareaClass: string
  errorMessageLine: string
}): string {
  return `        <Controller
          control={form.control}
          name="${name}"
          render={({ field }) => (
            <div className="${fieldContainerClassFill}">
              ${formLabelWithDescriptionLine}
              <textarea
                id="${name}"
                placeholder="${placeholder}"
                value={field.value ?? ''}
                onChange={field.onChange}
                onBlur={field.onBlur}
                name={field.name}
                ref={field.ref}
                className="${textareaClass}"
              />
${errorMessageLine}
            </div>
          )}
        />`
}

function renderFieldJsxChangeHandlerTemplate({
  escapeAttribute,
  escapeAttributeText,
  jsString,
  escapeJsx
}: {
  escapeAttribute: string
  escapeAttributeText: string
  jsString: string
  escapeJsx: string
}): string {
  return `                  <label htmlFor="${escapeAttribute}" className="flex items-center gap-2 text-sm font-medium leading-none">
                    <input
                      type="radio"
                      id="${escapeAttribute}"
                      value="${escapeAttributeText}"
                      checked={field.value === ${jsString}}
                      onChange={() => field.onChange(${jsString})}
                      onBlur={field.onBlur}
                      name={field.name}
                      ref={field.ref}
                      className="size-4 accent-primary"
                    />
                    <span>${escapeJsx}</span>
                  </label>`
}

function renderFieldJsxFieldControllerSpaceTemplate({
  name,
  fieldContainerClass,
  formLabelWithDescriptionLine,
  radioItems,
  errorMessageLine
}: {
  name: string
  fieldContainerClass: string
  formLabelWithDescriptionLine: string
  radioItems: string
  errorMessageLine: string
}): string {
  return `        <Controller
          control={form.control}
          name="${name}"
          render={({ field }) => (
            <fieldset className="${fieldContainerClass}">
              ${formLabelWithDescriptionLine}
              <div className="flex flex-col gap-3">
${radioItems}
              </div>
${errorMessageLine}
            </fieldset>
          )}
        />`
}

function renderFieldJsxFieldControllerEscapedJsxTemplate({
  name,
  fieldContainerClass,
  formLabelWithDescriptionLine,
  selectClass,
  escapeJsx,
  optionItems,
  errorMessageLine
}: {
  name: string
  fieldContainerClass: string
  formLabelWithDescriptionLine: string
  selectClass: string
  escapeJsx: string
  optionItems: string
  errorMessageLine: string
}): string {
  return `        <Controller
          control={form.control}
          name="${name}"
          render={({ field }) => (
            <div className="${fieldContainerClass}">
              ${formLabelWithDescriptionLine}
              <select
                id="${name}"
                value={field.value ?? ''}
                onChange={field.onChange}
                onBlur={field.onBlur}
                name={field.name}
                ref={field.ref}
                className="${selectClass}"
              >
                <option value="">${escapeJsx}</option>
${optionItems}
              </select>
${errorMessageLine}
            </div>
          )}
        />`
}

function renderFieldJsxChangeHandlerEscapedJsxTemplate({
  escapeAttribute,
  jsString,
  escapeJsx
}: {
  escapeAttribute: string
  jsString: string
  escapeJsx: string
}): string {
  return `                  <label htmlFor="${escapeAttribute}" className="flex items-center gap-2 text-sm font-medium leading-none">
                    <input
                      type="checkbox"
                      id="${escapeAttribute}"
                      checked={Array.isArray(field.value) ? field.value.includes(${jsString}) : false}
                      onChange={(event) => {
                        const currentValue = Array.isArray(field.value) ? field.value : []
                        field.onChange(
                          event.target.checked
                            ? [...currentValue, ${jsString}]
                            : currentValue.filter((value) => value !== ${jsString})
                        )
                      }}
                      onBlur={field.onBlur}
                      name={field.name}
                      ref={field.ref}
                      className="mt-0.5 size-4 rounded border-input accent-primary"
                    />
                    <span>${escapeJsx}</span>
                  </label>`
}

function renderFieldJsxFieldControllerSpaceBranchTemplate({
  name,
  fieldContainerClass,
  formLabelWithDescriptionLine,
  checkboxItems,
  errorMessageLine
}: {
  name: string
  fieldContainerClass: string
  formLabelWithDescriptionLine: string
  checkboxItems: string
  errorMessageLine: string
}): string {
  return `        <Controller
          control={form.control}
          name="${name}"
          render={({ field }) => (
            <fieldset className="${fieldContainerClass}">
              ${formLabelWithDescriptionLine}
              <div className="flex flex-col gap-3">
${checkboxItems}
              </div>
${errorMessageLine}
            </fieldset>
          )}
        />`
}

function renderFieldJsxFieldControllerFlexTemplate({
  name,
  fieldContainerClass,
  formLabelWithDescriptionLine,
  errorMessageLine
}: {
  name: string
  fieldContainerClass: string
  formLabelWithDescriptionLine: string
  errorMessageLine: string
}): string {
  return `        <Controller
          control={form.control}
          name="${name}"
          render={({ field }) => (
            <div className="${fieldContainerClass}">
              <input
                type="checkbox"
                id="${name}"
                checked={Boolean(field.value)}
                onChange={(event) => field.onChange(event.target.checked)}
                onBlur={field.onBlur}
                name={field.name}
                ref={field.ref}
                className="mt-1 size-4 rounded border-input accent-primary"
              />
              <div className="space-y-2 leading-none">
                ${formLabelWithDescriptionLine}
${errorMessageLine}
              </div>
            </div>
          )}
        />`
}

export function renderFormPipelineFieldJsxRenderer(
  request:
    | {
        kind: 'renderFieldJsxFieldControllerTemplate'
        props: {
          name: string
          fieldContainerClassFill: string
          formLabelWithDescriptionLine: string
          placeholder: string
          textareaClass: string
          errorMessageLine: string
        }
      }
    | {
        kind: 'renderFieldJsxChangeHandlerTemplate'
        props: {
          escapeAttribute: string
          escapeAttributeText: string
          jsString: string
          escapeJsx: string
        }
      }
    | {
        kind: 'renderFieldJsxFieldControllerSpaceTemplate'
        props: {
          name: string
          fieldContainerClass: string
          formLabelWithDescriptionLine: string
          radioItems: string
          errorMessageLine: string
        }
      }
    | {
        kind: 'renderFieldJsxFieldControllerEscapedJsxTemplate'
        props: {
          name: string
          fieldContainerClass: string
          formLabelWithDescriptionLine: string
          selectClass: string
          escapeJsx: string
          optionItems: string
          errorMessageLine: string
        }
      }
    | {
        kind: 'renderFieldJsxChangeHandlerEscapedJsxTemplate'
        props: {
          escapeAttribute: string
          jsString: string
          escapeJsx: string
        }
      }
    | {
        kind: 'renderFieldJsxFieldControllerSpaceBranchTemplate'
        props: {
          name: string
          fieldContainerClass: string
          formLabelWithDescriptionLine: string
          checkboxItems: string
          errorMessageLine: string
        }
      }
    | {
        kind: 'renderFieldJsxFieldControllerFlexTemplate'
        props: {
          name: string
          fieldContainerClass: string
          formLabelWithDescriptionLine: string
          errorMessageLine: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderFieldJsxFieldControllerTemplate':
      return renderFieldJsxFieldControllerTemplate(request.props)
    case 'renderFieldJsxChangeHandlerTemplate':
      return renderFieldJsxChangeHandlerTemplate(request.props)
    case 'renderFieldJsxFieldControllerSpaceTemplate':
      return renderFieldJsxFieldControllerSpaceTemplate(request.props)
    case 'renderFieldJsxFieldControllerEscapedJsxTemplate':
      return renderFieldJsxFieldControllerEscapedJsxTemplate(request.props)
    case 'renderFieldJsxChangeHandlerEscapedJsxTemplate':
      return renderFieldJsxChangeHandlerEscapedJsxTemplate(request.props)
    case 'renderFieldJsxFieldControllerSpaceBranchTemplate':
      return renderFieldJsxFieldControllerSpaceBranchTemplate(request.props)
    case 'renderFieldJsxFieldControllerFlexTemplate':
      return renderFieldJsxFieldControllerFlexTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
